import React from 'react'
import { QuarantineNotificationPageLoader } from 'v2/modules/userSettings'
import QuarantineNotification from 'components/pages/settings/quarantineNotification/QuarantineNotification'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const QuarantineNotificationSelector = () => {
  const isRolledOut = isMyFeatureOn(FEATURES.EGD_React_QNS_Admin_Quarantine_Notification_Rollout)

  switch (true) {
    case isRolledOut: {
      return <QuarantineNotificationPageLoader />
    }
    default: {
      return <QuarantineNotification />
    }
  }
}

export default QuarantineNotificationSelector
